export default {
  namespaced: true,
  state     : {
    profile_menu: [
      {
        text: 'Редактировать информацию о себе',
        icon: 'edit',
      },
      {
        text: 'Изменить пароль',
        icon: 'password',
      },
      {
        text: 'Настроить уведомления',
        icon: 'bell',
      },

    ],
  },
  getters: {
    profile_menu: ({profile_menu}) => profile_menu,
  },
};
